export const messages = {
  en: {
    visitUndo: {
      title: 'Visitor To-do List',
      back: 'Back',
      refresh: 'Refresh',
      visitorId: 'Visitor ID',
      visitor: 'Visitor',
      male: 'Male',
      female: 'Female',
      ownerName: 'Owner Name',
      visitReason: 'Visit Reason/Type',
      carNumber: 'Car Number',
      entourageCount: 'Entourage Count',
      createTime: 'Create Time',
      visitTime: 'Visit/Departure Time',
      status: 'Status',
      operation: 'Operation',
      process: 'Process',
      detail: 'Detail'
    }
  },
  zh: {
    visitUndo: {
      title: '访客待办单',
      back: '返回',
      refresh: '刷新',
      visitorId: '访客ID',
      visitor: '访客',
      male: '男',
      female: '女',
      ownerName: '业主姓名',
      visitReason: '来访事由/类型',
      carNumber: '车牌号',
      entourageCount: '随行人数',
      createTime: '创建时间',
      visitTime: '来访/离开时间',
      status: '状态',
      operation: '操作',
      process: '办理',
detail: '详情'
    }
  },
  'zh-TW': {
    visitUndo: {
      title: '訪客待辦單',
      back: '返回',
      refresh: '刷新',
      visitorId: '訪客ID',
      visitor: '訪客',
      male: '男',
      female: '女',
      ownerName: '業主姓名',
      visitReason: '來訪事由/類型',
      carNumber: '車牌號',
      entourageCount: '隨行人數',
      createTime: '創建時間',
      visitTime: '來訪/離開時間',
      status: '狀態',
      operation: '操作',
      process: '辦理',
      detail: '詳情'
    }
  }
}